<template>
  <b-row>
    <b-col cols="12" class="mb-3">
      <h1>Техническая поддержка</h1>
    </b-col>

    <b-col cols="8">
      <TicketForm />
    </b-col>

    <b-col cols="4">
      <TicketList />
    </b-col>

    <TicketCard />
  </b-row>
</template>

<script>
import TicketForm from "@components/ticket/TicketForm";
import TicketList from "@components/ticket/TicketList";
import TicketCard from "@components/ticket/TicketCard";

export default {
  components: {
    TicketForm,
    TicketList,
    TicketCard
  },
};
</script>

<style lang="scss" src="~/components/tickets/index.scss" />
